var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('span',[_vm._v(_vm._s(_vm.category.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }